import listActions from 'src/modules/planificadorFormulario/list/planificadorFormularioListActions';
import PlanificadorFormularioService from 'src/modules/planificadorFormulario/planificadorFormularioService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PLANIFICADORFORMULARIO_DESTROY';

const planificadorFormularioDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorFormularioDestroyActions.DESTROY_STARTED,
      });

      await PlanificadorFormularioService.destroyAll([id]);

      dispatch({
        type: planificadorFormularioDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.planificadorFormulario.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/planificador-formulario');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: planificadorFormularioDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorFormularioDestroyActions.DESTROY_ALL_STARTED,
      });

      await PlanificadorFormularioService.destroyAll(ids);

      dispatch({
        type: planificadorFormularioDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.planificadorFormulario.destroyAll.success'),
      );

      getHistory().push('/planificador-formulario');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: planificadorFormularioDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default planificadorFormularioDestroyActions;
